import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="relative overflow-hidden">
      <section data-testid="payment-cancel-page" className="relative z-10 mx-auto flex min-h-screen w-full max-w-2xl flex-col items-center justify-center px-6 py-40 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="w-full rounded-3xl border border-white/10 bg-surface px-8 py-14 md:px-16"
        >
          <XCircle className="mx-auto h-12 w-12 text-white/40" />
          <h1 className="mt-6 font-display text-3xl font-semibold tracking-tight">
            Payment cancelled.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-lg font-light leading-relaxed text-fog">
            No charge was made. Whenever you are ready, the backing tiers are waiting.
          </p>
          <Link
            to="/subscribe"
            data-testid="payment-cancel-retry-link"
            className="bg-gradient-accent mt-10 inline-flex items-center gap-3 rounded-full px-10 py-4 text-base font-semibold text-white transition-opacity duration-300 hover:opacity-90"
          >
            Back to Subscribe
          </Link>
        </motion.div>
      </section>
    </main>
  );
}
